import type { TopBarAction } from '@/modules';

/**
 * Props for the topbar.
 *
 * @since 1.0.0
 */
export interface TopBarProps {
    title: string;
    actions?: TopBarAction[];
    onAction?: (actionId: string) => void;
    navId?: string;
    isNavOpen?: boolean;
    onToggleNav?: () => void;
}

/**
 * The sticky header above the routed page: the view title, its action buttons, and on a
 * narrow screen the button that reveals the sidebar.
 *
 * @since 1.0.0
 * @param props - the title, optional action buttons and their dispatcher, and the sidebar
 *     toggle for the narrow layout
 * @returns the topbar element
 */
export function TopBar({ title, actions = [], onAction, navId, isNavOpen = false, onToggleNav }: TopBarProps) {
    return (
        <div className="fkwd-topbar">
            {onToggleNav === undefined ? null : (
                <button
                    aria-controls={navId}
                    aria-expanded={isNavOpen}
                    className="fkwd-btn fkwd-topbar__menu"
                    onClick={onToggleNav}
                    type="button"
                >
                    Menu
                </button>
            )}
            <h1>{title}</h1>
            <span className="fkwd-spacer" />
            <span className="fkwd-topbar__actions">
                {actions.map((action) => (
                    <button
                        className={action.variant === 'dark' ? 'fkwd-btn fkwd-btn--dark' : 'fkwd-btn'}
                        key={action.id}
                        onClick={() => onAction?.(action.id)}
                        type="button"
                    >
                        {action.label}
                    </button>
                ))}
            </span>
        </div>
    );
}
